import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

import Loader from "@/components/loader";
// import { useBrandColorContext } from "@/contexts/BrandColorContext";
import { useBreakpoint } from "@/hooks/userBreakPoint";
// import { FormattedMessage } from "@/i18n";
// import { Link } from "@/ui";

import { DashboardHeader } from "./DashboardHeader";
import { DASHBOARD_LAYOUT_CONTENT_ID } from "./DashboardLayout.constants";
import { DashboardScopeGate } from "./DashboardScopeGate";
import { DashboardSidebar } from "./DashboardSidebar";

export const DashboardLayout = () => {
  // const { supportEmail } = useBrandColorContext();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isSmallScreen = useBreakpoint("md", "down");
  const location = useLocation();

  useEffect(() => {
    if (isDrawerOpen && isSmallScreen) {
      setIsDrawerOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className="flex h-full overflow-auto w-full">
      <DashboardSidebar isOpen={isDrawerOpen} onOpenChange={setIsDrawerOpen} />
      <div
        id={DASHBOARD_LAYOUT_CONTENT_ID}
        className="flex-1 flex flex-col relative overflow-auto [scrollbar-gutter:stable]"
      >
        <DashboardHeader
          onMenuClick={() => {
            setIsDrawerOpen(true);
          }}
        />
        <div className="flex-1 bg-new-background md:p-5 p-4 flex flex-col">
          <Suspense
            fallback={
              <div className="flex-1 flex items-center justify-center">
                <Loader />
              </div>
            }
          >
            <DashboardScopeGate>
              <Outlet />
            </DashboardScopeGate>
          </Suspense>
          {/* <p className="preset-body-md text-new-primary text-center mt-auto py-8">
            <FormattedMessage
              i18nKey={"general.components.supportFooter.text"}
              values={{ supportEmail }}
              components={{
                supportEmailLink: (
                  <Link to={`mailto:${supportEmail}`} target="_blank">
                    {supportEmail}
                  </Link>
                ),
              }}
            />
          </p> */}
        </div>
      </div>
    </div>
  );
};
